module.exports = __webpack_public_path__ + "img/socialCommitment.c9992d6b.png";